import Image from '@components/Image';
import { IconLogo } from '@components/icons/IconLogo';
import useEditingStore from '@hooks/useEditingStore';
import useLangString from '@hooks/useLangString';
import useTemplateFeature from '@hooks/useTemplateFeature';
import { $tourData } from '@stores/dataStores';
import {
  $editingFlag,
  $editingLogo,
  $editingUIColor,
} from '@stores/editingStores';
import { ImageType, LogoType, TemplateId } from '@types';
import { getTemplateConfig } from '@utils/templateConfig';
import { WFirstSceneButton } from '../WFirstSceneButton';
import WLogo from '../WLogo';
import useNickname from '../useNickname';

export function WUserInfoREB() {
  const { name } = useNickname();
  const hasLogo = useTemplateFeature('logo');
  const flag = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.flag,
    $editing: $editingFlag.store,
  });
  const logo = useEditingStore({
    $data: $tourData,
    dataFn: (state) => state.logo,
    $editing: $editingLogo.store,
  });
  const ui = useEditingStore({
    $data: $tourData,
    dataFn: (state) => {
      const ui = state.config?.ui;
      const defaultUI =
        getTemplateConfig(TemplateId.realEstateB)('uiColor') ?? {};
      if (!ui) return defaultUI;
      return { ...defaultUI, ...ui };
    },
    $editing: $editingUIColor.store,
  });

  const logoType = hasLogo ? logo?.type ?? LogoType.system : LogoType.system;
  const scale = logo?.scale ?? 1;

  const lang = useLangString(
    {
      author: ['创作者：', 'Author: '],
      pv: ['～人来过', '～ views'],
    },
    []
  );

  const showName = !!(flag?.showAuthorName ?? 1);
  const showPv = !!(flag?.showTourPV ?? 1);

  const renderLogo = () => {
    if (logoType === LogoType.system) {
      return (
        <WLogo
          systemIcon={
            <IconLogo
              className="mr-20 mt-2"
              width={60}
              color={`rgba(${ui.fontColor})`}
            />
          }
        />
      );
    }
    if (logoType === LogoType.custom) {
      return logo?.iconMediaUrl ? (
        <Image
          className="mr-20"
          style={{
            maxWidth: 70 * scale,
            maxHeight: 70 * scale,
            objectFit: 'scale-down',
            objectPosition: 'left',
          }}
          src={logo.iconMediaUrl}
          type={ImageType.media}
        />
      ) : (
        <div
          className="mr-20 flex h-70 w-70 items-center justify-center text-center text-sm"
          style={{
            backgroundColor: 'rgba(40, 110, 250, 0.3)',
            border: '1px solid #286efa',
          }}
        >
          还未添加LOGO
        </div>
      );
    }
    return null;
  };

  return (
    <div className="absolute top-20 left-20">
      <div className="flex">
        {renderLogo()}
        {(showName || showPv) && (
          <div style={{ color: `rgba(${ui.fontColor})` }}>
            {showName && <div className="mb-5">{`${lang.author}${name}`}</div>}
            {showPv && <div className="text-sm">{lang.pv}</div>}
          </div>
        )}
      </div>
      <WFirstSceneButton />
    </div>
  );
}
